import ResultLogo from "@components/job_search/search_result_card/result_logo.tsx";
import TitleCompany from "@components/job_search/search_result_card/title_company.tsx";
import Tags from "@components/job_search/search_result_card/tags.tsx";
import Footer from "@components/job_search/search_result_card/footer.tsx";
import { Link } from "@sprout/typography.tsx";
import { router } from "@inertiajs/react";
import { type MouseEvent } from "react";

interface Props {
  id: string;
  title: string;
  company: string;
  logoUrl: string;
  locations?: string[];
  workType?: string | null;
  payRange?: string;
  publishedAt: string;
  url: string;
  external?: boolean;
  loading?: boolean;
  trackClick?: () => void;
  viewed: boolean;
  onView: (id: string) => void;
}

export const SearchResultCard = ({
  id,
  title,
  company,
  logoUrl,
  locations,
  workType,
  payRange,
  publishedAt,
  url,
  external,
  loading,
  trackClick,
  viewed,
  onView,
}: Props) => {
  const isExternal = external ?? true;

  const handleCardClick = (e: MouseEvent) => {
    if (loading) {
      e.preventDefault();
      return;
    }
    trackClick?.();
    if (!viewed) {
      onView(id);
    }
    if (!isExternal) {
      e.preventDefault();
      router.replaceProp("jobPost", undefined);
      fetch(url, {
        headers: { "X-Modal-Request": "true" },
        credentials: "same-origin",
      })
        .then((r) => (r.ok ? r.json() : Promise.reject()))
        .then((data) => {
          router.replaceProp("jobPost", data.jobPost);
          router.replaceProp("boardConfiguration", data.boardConfiguration);
          router.replaceProp("submitPath", data.submitPath);
          router.replaceProp("educationApiUrl", data.educationApiUrl);
          router.replaceProp("dreamJobAvailable", data.dreamJobAvailable);
        })
        .catch(() => {
          router.visit(url, { preserveScroll: true });
        });
    }
  };

  return (
    <div
      data-provides="search-result"
      data-loading={loading ? "true" : "false"}
      className={`border rounded-lg border-solid border-[var(--gray-700)] hover:bg-[var(--pale-blue)] ${
        viewed ? "bg-[var(--object-fills-grey)]" : "bg-white"
      }`}
    >
      <Link
        href={url}
        external={isExternal}
        onClick={handleCardClick}
        className="flex flex-col px-6 py-4 gap-4 justify-between no-underline! text-inherit! hover:brightness-100! focus:brightness-100!"
      >
        <div className="flex flex-row items-center gap-2">
          <ResultLogo loading={loading} company={company} logoUrl={logoUrl} />
          <div className="flex flex-col">
            <TitleCompany loading={loading} company={company} title={title} />
          </div>
        </div>
        <Tags loading={loading} locations={locations} workType={workType} payRange={payRange} />
        <div className="flex flex-row items-center justify-between">
          <Footer loading={loading} publishedAt={publishedAt} viewed={viewed} />
        </div>
      </Link>
    </div>
  );
};
